(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86663,19341,97],{

/***/ 86663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_AssessmentCtaSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/sections/AssessmentCtaSection/AssessmentCtaSection.module.scss
var AssessmentCtaSection_module = __webpack_require__(99772);
var AssessmentCtaSection_module_default = /*#__PURE__*/__webpack_require__.n(AssessmentCtaSection_module);
;// CONCATENATED MODULE: ./UI/sections/AssessmentCtaSection/utils/useCardsSection.js









/* harmony default export */ function useCardsSection(_param) {
    var section = _param.section, type = _param.type, sectionWithSlider = _param.withSlider, withOverlay = _param.withOverlay, data = _param.data, handleOnCTAClickCommon = _param.handleOnCTAClick, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "section",
        "type",
        "withSlider",
        "withOverlay",
        "data",
        "handleOnCTAClick"
    ]);
    var ref = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "description",
        "formattedDescription",
        "contentModules",
        "subtitle",
        "view",
        "images", 
    ], {
        isNormilized: data && !Object.keys(data).includes("fields") || section && !Object.keys(section).includes("fields")
    }), title = ref.title, description = ref.description, formattedDescription = ref.formattedDescription, subtitle = ref.subtitle, view = ref.view, contentModules = ref.contentModules, rawImages = ref.images;
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", []), [
        "contentModules",
        "withoutBackground",
        "disableSliderOnMobile",
        "enableSliderOnDesktop",
        "enableSliderOnMobile",
        "svgWithWrapper", 
    ]), disableSliderOnMobile = ref1.disableSliderOnMobile, enableSliderOnDesktop = ref1.enableSliderOnDesktop, enableSliderOnMobile = ref1.enableSliderOnMobile;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isTabletResolution = (0,es.useSelector)(layout/* selectIsTablet */.aT);
    var isSmallTabletResolution = (0,es.useSelector)(layout/* selectIsSmallTablet */.Bw);
    var withSlider = sectionWithSlider || enableSliderOnDesktop || !disableSliderOnMobile && (isTabletResolution || isSmallTabletResolution || isMobileResolution) || enableSliderOnMobile && isMobileResolution;
    var className = classnames_default()((AssessmentCtaSection_module_default()).cardsSection, (AssessmentCtaSection_module_default())[type], (AssessmentCtaSection_module_default())[view], (0,_define_property/* default */.Z)({}, (AssessmentCtaSection_module_default()).withSlider, withSlider));
    return (0,_object_spread/* default */.Z)({
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/sections/AssessmentCtaSection/index.jsx







var AssessmentCtaSection = function(props) {
    var className = useCardsSection(props).className;
    // DEPRICATED
    // const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AssessmentCtaSection_module_default()).sectionContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
            path: routes/* routes.assessments.path */._.assessments.path,
            className: classnames_default()((AssessmentCtaSection_module_default()).badge),
            children: [
                "Take Assessment",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (AssessmentCtaSection_module_default()).arrow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                        type: "arrowRight",
                        className: (AssessmentCtaSection_module_default()).icon
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_AssessmentCtaSection = (AssessmentCtaSection);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 99772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"AssessmentCtaSection_cardsWithFullWidthImage__RKVSr","cards":"AssessmentCtaSection_cards__tZbl0","imageWrapper":"AssessmentCtaSection_imageWrapper__Fh6ex","typeTitle":"AssessmentCtaSection_typeTitle__DEQHc","greySection":"AssessmentCtaSection_greySection__nj85t","callToAction":"AssessmentCtaSection_callToAction__xkg9D","threeColumnsCards":"AssessmentCtaSection_threeColumnsCards__1POWQ","twoColumnsCards":"AssessmentCtaSection_twoColumnsCards__BYlVK","textContent":"AssessmentCtaSection_textContent__g6NvO","sectionContainer":"AssessmentCtaSection_sectionContainer__n5Nvt","badge":"AssessmentCtaSection_badge__31hFj","arrow":"AssessmentCtaSection_arrow__XLdQa","isHidden":"AssessmentCtaSection_isHidden__05V6I","close":"AssessmentCtaSection_close__QjIVv","cardsSection":"AssessmentCtaSection_cardsSection__xLqXL","isOpen":"AssessmentCtaSection_isOpen__iqjgX"};

/***/ })

}]);